import axios from "../utils/api-client";

const API_BASE_URL = `${process.env.REACT_APP_API_END_POINT}/LineActivities`;

/** cleaning | changeover | maintenance | setup | lab */
export type LineActivityKind = "cleaning" | "changeover" | "maintenance" | "setup" | "lab";

export interface LineActivityType {
	id: number;
	code: string;
	name: string;
	kind: LineActivityKind;
	description?: string | null;
	sortOrder: number;
	isActive: boolean;
}

/** An activity's time on a machine: for every product (no productId) or for one product. */
export interface LineActivityTime {
	id: number;
	locationId: number;
	activityTypeId: number;
	workstation: string;
	productId?: number | null;
	minutes: number;
	waitMinutes: number;
}

export interface SaveLineActivityType {
	id?: number;
	name: string;
	kind: LineActivityKind;
	description?: string | null;
	isActive: boolean;
}

export interface SaveLineActivityTime {
	locationId: number;
	activityTypeId: number;
	workstation: string;
	productId?: number | null;
	/** null clears the time (a product's own time then falls back to the machine's). */
	minutes: number | null;
	waitMinutes: number;
}

export const lineActivitiesApi = {
	get: async (locationId: number): Promise<{ types: LineActivityType[]; times: LineActivityTime[] }> => {
		const response = await axios.get(API_BASE_URL, { params: { locationId } });
		return { types: response.data?.types ?? [], times: response.data?.times ?? [] };
	},
	saveType: async (type: SaveLineActivityType): Promise<LineActivityType> => {
		const response = await axios.post(`${API_BASE_URL}/types`, type);
		return response.data;
	},
	/** Returns the saved row, or null when the time was cleared. */
	saveTime: async (time: SaveLineActivityTime): Promise<LineActivityTime | null> => {
		const response = await axios.put(`${API_BASE_URL}/times`, time);
		return response.status === 204 ? null : response.data;
	},
};

export default lineActivitiesApi;
